import React from 'react';
import { C } from '../../shared/design-tokens.js';

export const CONTROL_INPUT: React.CSSProperties = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: 8,
  border: `1px solid ${C.borderSoft}`,
  background: 'rgba(7, 11, 18, 0.72)',
  color: C.text,
  fontSize: 14,
  boxSizing: 'border-box',
};

export const MUTED_LABEL: React.CSSProperties = {
  display: 'block',
  color: C.textMuted,
  fontSize: 12,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginBottom: 6,
};

export function formatMeetingDate(val: string | null | undefined): string {
  if (!val) return '\u2014';
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return String(val).slice(0, 10);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function meetingStatusPresentation(status: string) {
  switch (status) {
    case 'open':   return { label: 'Open',   color: C.green, background: 'rgba(78,205,196,0.12)' };
    case 'closed': return { label: 'Closed', color: C.textMuted, background: 'rgba(255,255,255,0.05)' };
    default:       return { label: status || 'Unknown', color: C.textMuted, background: 'rgba(255,255,255,0.05)' };
  }
}
